import { DTO__generation_tool } from '@shared/dto/generation/DTO__generation_tool';
import { FIELD__base } from '../../_fields/_base/FIELD__base';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { ENUM__invocation_role } from '../../_invocations/_base/ENUM__invocation_role';
import { INVOCATION_GRID2D__view } from '../../_invocations/grid2d/INVOCATION_GRID2D__view';
import { INVOCATION_VISION_ML__control_line_guidance_hed } from '../../_invocations/vision/line_guidance/INVOCATION_VISION_ML__control_line_guidance_hed';
import { ENUM__graph_template_name } from '../sd_1/ENUM__graph_template_name';

export function GENERATION_TOOL__vision__hed() {
  let out = new DTO__generation_tool();
  out.name = ENUM__graph_template_name.CREATE_LINES_HED;

  const graph = DTO_GRAPH__instance.CREATE_NEW();
  out.graph = graph;

  /*
   *  GRID2D
   */
  const node__grid2d = INVOCATION_GRID2D__view.create_node_for(graph);

  /*
   *
   */

  const node__line_guidance_hed = INVOCATION_VISION_ML__control_line_guidance_hed.create_node_for(graph, ENUM__invocation_role.VISION__LINE_HED);
  graph.edge__try_add_for_fields(node__line_guidance_hed.out, node__grid2d.image);

  /*
   *
   */

  /*
   * UI
   */

  let fields__visible: FIELD__base[] = [node__line_guidance_hed.image, node__line_guidance_hed.scribble, node__line_guidance_hed.model];
  let field_column_id = node__line_guidance_hed.model.meta.field_id;
  let field_row_id = node__line_guidance_hed.scribble.meta.field_id;

  out.view__add({
    fields__visible,
    //
    fields__stored: fields__visible,
    //
    field_column_id,
    field_row_id,
  });

  /*
   *
   */

  return out;
}
